import { $, $$ } from '@zimpa/dom';

const ROOT_SELECTOR = '.js-menu-main';
const CONTAINER_SELECTOR = '.js-menu-container';
const TOGGLE_SELECTOR = '.js-menu-toggle';
const LABEL_SELECTOR = '.js-menu-label';
const COLLAPSED_CLASS = 'collapsed';

class MainMenu {
    private _main: HTMLDivElement;
    private _container: HTMLDivElement;
    private _toggle: HTMLButtonElement;
    private _collapsed: boolean;
    public constructor() {
        const main = $<HTMLDivElement>(ROOT_SELECTOR);
        const container = $<HTMLDivElement>(CONTAINER_SELECTOR);
        const toggle = $<HTMLButtonElement>(TOGGLE_SELECTOR);

        if (main === undefined || toggle === undefined || container === undefined) {
            return;
        }

        this._main = main;
        this._container = container;
        this._toggle = toggle;
        this._collapsed = true;


        this.init();
    }

    private init() {

        this._toggle.addEventListener('click', (e): void => {
            e.stopPropagation()
            e.preventDefault()
            this._collapsed = !this._collapsed;
            this.setState()
        });

        this._container.addEventListener('focusout',e => {
            if(e.relatedTarget === this._toggle ){
                return;
            }
            if(!this._container.contains(e.relatedTarget as HTMLElement)) {
                this._collapsed = true;
                this.setState()
            }
        })

    }

    private setState() {
        this._toggle.setAttribute('aria-expanded', `${!this._collapsed}`);
        const label = $<HTMLSpanElement>(LABEL_SELECTOR);
        if (this._collapsed) {
            this._main.classList.add(COLLAPSED_CLASS)
            this._toggle.classList.add(COLLAPSED_CLASS)
            if(label !== undefined) {
                label.innerText = 'Open menu'
            }
        } else {
            this._main.classList.remove(COLLAPSED_CLASS)
            this._toggle.classList.remove(COLLAPSED_CLASS)
            this._container.focus();
            if(label !== undefined) {
                label.innerText = 'Sluit menu'
            }
        }

    }

}

export function menu(): void {
    new MainMenu();
}
